import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import deliveryCompanyRequestHandler from '../../../api/deliveryCompanyRemote';

import NotifyTruckingCompany from './notifyTruckingCompany';

import User from '../../../models/User';
import PickupOrder from '../../../models/PickupOrder';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import DeliveryCompany from '../../../models/DeliveryCompany';

import validation from '../../../utils/validation';
import { handlePrintPickupOrder } from '../../../utils/printing';
import TruckDriverData from '../../../models/TruckDriverData';

const PREFIX_PHONE_NUMBER: string = '+1';

interface NotifyTruckingCompanyProps {
  user: User;
  receiveError: Function;
  receiveSuccess: Function;
  pickupOrder: PickupOrder;
  notifyWho: string;
  secretKey?: string;
  direct?: boolean;
  selectedDeliveryCompanyID?: number | undefined;
  selectedDriverID?: number | undefined;
};

interface NotifyTruckingCompanyState {
  email: string;
  phoneNumber: string;
  notifyBy: string;
  isPhoneNumber: boolean;
  isEmail: boolean;
};

class NotifyTruckingCompanyContainer extends Component<NotifyTruckingCompanyProps, NotifyTruckingCompanyState> {

  state = {
    email: '',
    phoneNumber: '',
    notifyBy: 'email',
    isPhoneNumber: true,
    isEmail: true
  }

  componentDidMount() {
    if(this.props.notifyWho === 'truckingCompany') {
      this.getDeliveryCompany(this.props.selectedDeliveryCompanyID);
    } else {
      this.getDriver(this.props.selectedDriverID)
    }
  }

  componentDidUpdate(prevProps: NotifyTruckingCompanyProps) {

    if (this.props.selectedDeliveryCompanyID != prevProps.selectedDeliveryCompanyID) {

      this.getDeliveryCompany(this.props.selectedDeliveryCompanyID);
    }
    if (this.props.selectedDriverID != prevProps.selectedDriverID) {

      this.getDriver(this.props.selectedDeliveryCompanyID);
    }
  }

  getDeliveryCompany = (companyID: number | undefined): void => {

    if (companyID && companyID> 0) {

      deliveryCompanyRequestHandler.getDeliveryCompanyById(companyID).then((resp: ApiResponse<DeliveryCompany>) => {

        const deliveryCompany: DeliveryCompany | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (deliveryCompany) {
          this.setState({
            email: deliveryCompany.default_email || '',
            phoneNumber: deliveryCompany.default_sms || ''
          })
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      this.setState({
        email: '',
        phoneNumber: ''
      })
    }
  }

  getDriver = (driverId: number | undefined): void => {

    if (driverId && driverId> 0) {

      deliveryCompanyRequestHandler.getDriverById(driverId).then((resp: ApiResponse<TruckDriverData>) => {

        const truckDriver: TruckDriverData | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (truckDriver) {
          this.setState({
            email: truckDriver.default_email || '',
            phoneNumber: truckDriver.default_sms || ''
          })
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      this.setState({
        email: '',
        phoneNumber: ''
      })
    }
  }

  handleChange = (name: string) => (event: any): void => {

    switch(name) {
      case 'notifyBy':
        this.setState({ notifyBy: event.target.value });        
        break;
      case 'email':
        this.setState({ email: event.target.value || '' }); 
        break;
      case 'phoneNumber':
        this.setState({ phoneNumber: event.target.value || ''}); 
        break;
      default: break;
    }
  }

  onValidationEmail = (): void => {

    if (this.state.email !== '') {

      const isEmail: boolean = validation.validateEmail(this.state.email);
      this.setState({ isEmail });

    } else {
      
      this.setState({ isEmail: true });
    };
  };

  onValidationPhoneNumber = (): void => {

    if (this.state.phoneNumber !== '') {

      const isPhoneNumber: boolean = validation.validatePhoneNumber(this.state.phoneNumber);
      this.setState({ isPhoneNumber });

    } else {

      this.setState({ isPhoneNumber: true });
    };
  };

  notifyTrucker = (): void => {
    
    const poNumber: string = this.props.pickupOrder.number;
    const contact: string = this.state.notifyBy === 'email' ? this.state.email : (PREFIX_PHONE_NUMBER + this.state.phoneNumber);
    const validContact = this.state.notifyBy === 'email' ? this.state.isEmail : this.state.isPhoneNumber;

    const afterNotify = (resp: ApiResponse<PickupOrder | boolean>) => {

      const result: PickupOrder | boolean | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.props.receiveSuccess('Message has been sent successfully.');
      }

      if (error) {
        this.props.receiveError(error);
      };
    }

    if (this.props.notifyWho === 'driver' && this.props.secretKey && validContact) {

      this.props.pickupOrder.driver_contact = contact;
      pickupOrderRemote.notifyDriver(this.props.secretKey, this.props.pickupOrder).then(afterNotify);

    } else if (this.props.notifyWho === 'truckingCompany' && validContact) {

      pickupOrderRemote.notifyTruckingCompany(poNumber, contact, true).then(afterNotify);
    } else if(this.props.direct) {
      this.props.pickupOrder.driver_contact = contact;
      pickupOrderRemote.notifyDriverDirect(this.props.pickupOrder, this.props.direct).then(afterNotify);
    }
  }

  printPrintPickupOrder = (): void => {

    const po: PickupOrder = this.props.pickupOrder;
    const secret: string | undefined = this.props.user.roleId !== 0 ? undefined : this.props.secretKey;

    if (po && po.number) {
      handlePrintPickupOrder(po.number, secret);
    }
  }

  render() {

    return (
      <NotifyTruckingCompany
        email={ this.state.email }
        phoneNumber={ this.state.phoneNumber }
        notifyBy={this.state.notifyBy}
        handleChange = {this.handleChange}
        isPhoneNumber={ this.state.isPhoneNumber }
        prefixPhoneNumber={ PREFIX_PHONE_NUMBER }
        isEmail={ this.state.isEmail }
        onValidationEmail={ this.onValidationEmail }
        onValidationPhoneNumber={ this.onValidationPhoneNumber }
        notifyTrucker={ this.notifyTrucker }
        notifyWho={ this.props.notifyWho }
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotifyTruckingCompanyContainer);
